import { Card } from 'blaze-ui/icons'
import Styles from './PaymentDetails.module.scss'
import { Button } from 'blaze-ui/Button'
import { useStripePaymentMethodUpdate } from 'hooks/useStripePaymentMethodUpdate'
import { getHref, getOrigin } from 'utils/location'
import { Spinner } from 'common/Spinner/Spinner'

interface Props {
  lastFour?: number
  className?: string
}

export const PaymentDetails = ({ lastFour }: Props) => {
  const successUrl = `${getOrigin()}/checkout-session?session_id={CHECKOUT_SESSION_ID}&redirect_to_billing=true`
  const { isProcessing, redirectToStripe } = useStripePaymentMethodUpdate(successUrl, getHref())

  return (
    <div className={Styles.container}>
      {!!lastFour && (
        <div className={Styles.cardContainer}>
          <Card size={20} />
          <p className={Styles.obscured}>•••• •••• ••••</p>
          <p>{lastFour}</p>
        </div>
      )}
      <Button variant="secondary" size="md" isDisabled={isProcessing} onPress={redirectToStripe}>
        {isProcessing && <Spinner />}
        {lastFour ? 'Edit Payment Method' : 'Add Payment Method'}
      </Button>
    </div>
  )
}
